import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from "./Components/Navbar"
import Home from "./Components/Home"
import AboutUs from './Components/AboutUs';
import CatusLMS from './Components/CatusLMS';
import Contact from "./Components/Contact"
import GetQuote from "./Components/GetQuote"
import Footer from "./Components/Footer"
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import WhatWeDo from './Components/WhatWeDo';
import IntegratedSolutionForAllDepartments from './Components/IntegratedSolutionForAllDepartments';
import LogisticsOperations from './Components/LogisticsOperations';
import CRM from './Components/CRM';
import AirExportLogisticsSoftware from './Components/AirExportLogisticsSoftware';
import SeaExportLogisticsSoftware from './Components/SeaExportLogisticsSoftware';
import SeaImportLogisticsSoftware from './Components/SeaImportLogisticsSoftware';
import AirImportLogisticsSoftware from './Components/AirImportLogisticsSoftware';
import FinancialAccountingSoftware from './Components/FinancialAccountingSoftware';
import CustomisedBusinessEmailServices from './Components/CustomisedBusinessEmailServices';
import WebsiteDevelopment from './Components/WebsiteDevelopment';
import logo from './img/whatsapp_logo.png';
// import logo from './img/Contact Icons/whatsapp.png';
import ScrollTop from './Components/ScrollTop';

function App() {
  return (
    <div className="app-background">
      <Router>
        <ScrollTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/CatusLMS" element={<CatusLMS />} />
          <Route path="/AirExportLogisticsSoftware" element={<AirExportLogisticsSoftware />} />
          <Route path="/SeaExportLogisticsSoftware" element={<SeaExportLogisticsSoftware />} />
          <Route path="/AirImportLogisticsSoftware" element={<AirImportLogisticsSoftware />} />
          <Route path="/SeaImportLogisticsSoftware" element={<SeaImportLogisticsSoftware />} />
          <Route path="/FinancialAccountingSoftware" element={<FinancialAccountingSoftware />} />
          <Route path="/CustomisedBusinessEmailServices" element={<CustomisedBusinessEmailServices />} />
          <Route path="/WebsiteDevelopment" element={<WebsiteDevelopment />} />
          <Route path="/IntegratedSolutionForAllDepartments" element={<IntegratedSolutionForAllDepartments />} />
          <Route path="/LogisticsOperations" element={<LogisticsOperations />} />
          <Route path="/CRM" element={<CRM />} />
          <Route path="/WhatWeDo" element={<WhatWeDo />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/GetQuote" element={<GetQuote />} />
        </Routes>
        <Footer />
      </Router>
      <div
        className="fixed-bottom p-3"
        style={{
          zIndex: 6,
          right: "20px",
          left: "auto",
        }}
      >
        <a
          href="https://wa.me/9899712724?"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with us on WhatsApp"
          style={{
            display: "inline-block",
            borderRadius: "50%",
            boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
            transition: "transform 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <img src={logo} alt="WhatsApp Logo" width={50} height={50} />
        </a>
      </div>
    </div>
  );
}
export default App;